<template>
  <div class="start flex-grow-1 flex-fill">
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-24 col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p
              class="min-h d-none d-md-flex"
              v-text="$ml.get('atBugHuntYouWillFindPrograms')"
            ></p>
            <p
              class="normal mt-4 min-h d-none d-md-flex"
              v-text="$ml.get('doYouHaveOrganizationAndDidYou')"
            >
              Possui uma organização e gostou do projeto?
            </p>
            <p
              class="min-h d-none d-md-flex"
              v-text="$ml.get('letStartYourRegistrationAnd')"
            >
              Vamos iniciar seu cadastro e logo um especialista irá entrar em
              contato com você para esclarecer as dúvidas e finalizar seu
              cadastro!
            </p>
            <router-link
              to="/company"
              class="btn btn-outline min-h d-none d-md-flex"
              v-text="$ml.get('startAnAccountForOrganization')"
            >
              Iniciar uma conta para organização!
            </router-link>
          </div>
          <div
            class="col-2 min-h d-none d-md-flex justify-content-center py-3 mb-5"
          >
            <span class="line align-self-center"></span>
          </div>

          <div
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-text="$ml.get('letsCreateYourAccount')">
                  Vamos criar sua conta!
                </h5>
                <p v-text="$ml.get('superSimpleItDoesntEvenTake')">
                  Super simples, não leva nem 1 minuto. Basta informar os dados
                  como nome, apelido, e-mail e senha e pronto! Sua conta está
                  criada.
                </p>
                <transition name="fade">
                  <div v-show="msgdanger" class="alert alert-danger">
                    {{ msgdanger }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgWarning" class="alert alert-warning">
                    {{ msgWarning }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgSuccess" class="alert alert-success">
                    <font
                      v-text="
                        $ml.with(msgSuccess).get('expertSuccessfullCreated')
                      "
                      >Especialista criado com sucesso!</font
                    >,
                    <font v-text="$ml.get('youWillBeRedirectedIn')"
                      >Você será redirecionado em</font
                    >
                    {{ seconds }}
                    <font v-text="$ml.get('seconds')">segundos</font>.
                  </div>
                </transition>
                <section>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="name"
                          :placeholder="$ml.get('yourFullName')"
                          maxlength="30"
                          :style="requestError === messageErrorApi.name ? 'border: 1px solid red;' : ''"
                        />
                        <transition name="fade">
                          <label
                            v-if="userError && !$v.name.required"
                            class="lblError"
                            v-text="$ml.get('enterYourFullName')"
                            >Digite seu nome</label
                          >
                          <label
                            class="lblError"
                            v-if="userError && !$v.name.minLength"
                            v-text="
                              $ml
                                .with('f', 3)
                                .with('l', 30)
                                .get('yourNameMustBeBetweenAndCharacters')
                            "
                            >Seu nome deve ter entre 3 e 30 caracteres!</label
                          >
                          <label
                            class="lblError"
                            v-if="userError && !$v.name.regexOTN"
                            v-text="$ml.get('cannotEnterSpecialCharacters')"
                            >Não é possível inserir caracteres especiais</label
                          >
                          <label
                            class="lblError"
                            v-if="requestError === messageErrorApi.name"
                            v-text="$ml.get('invalidName')"
                            >O nome inserido não é válido!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="username"
                          :placeholder="$ml.get('chooseANicknameYoursAlone')"
                          maxlength="30"
                        />
                        <transition name="fade">
                          <label
                            v-if="userError && !$v.username.required"
                            class="lblError"
                            v-text="$ml.get('enterTheUsername')"
                            >Digite seu apelido</label
                          >
                          <label
                            class="lblError"
                            v-if="userError && !$v.username.minLength"
                            v-text="
                              $ml
                                .with('f', 3)
                                .with('l', 30)
                                .get('usernameMustBeFromCharacters')
                            "
                            >Seu username deve ter entre 3 e 30
                            caracteres!</label
                          >
                          <label
                            class="lblError"
                            v-if="userError && !$v.username.regexRSC"
                            v-text="$ml.get('cannotEnterSpecialCharacters')"
                            >Não é possível inserir caracteres especiais</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="email"
                          :placeholder="$ml.get('enterYourPrimaryEmailAddress')"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="userError && !$v.email.required"
                            class="lblError"
                            v-text="$ml.get('enterTheEmail')"
                            >Digite o e-mail</label
                          >
                          <label
                            class="lblError"
                            v-if="userError && !$v.email.email"
                            v-text="$ml.get('emailDoesNotAppearToBeValid')"
                            >Este e-mail não parece estar válido</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="password"
                          :placeholder="$ml.get('aSuperStrongPasswordNow')"
                          maxlength="200"
                        />
                        <transition v-if="userError" name="fade">
                          <label class="lblError">{{
                            passwordValidation.errorsString
                          }}</label>
                        </transition>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="passwordConfirm"
                          :placeholder="$ml.get('confirmYourPassword')"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            class="lblError"
                            v-if="userError && !$v.passwordConfirm.required"
                            v-text="$ml.get('enterPasswordConfirmation')"
                            >Digite a confirmação de senha</label
                          >
                          <label
                            class="lblError"
                            v-if="
                              userError && !$v.passwordConfirm.sameAsPassword
                            "
                            v-text="$ml.get('passwordsMustMatch')"
                            >As senhas devem ser iguais!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col">
                      <multiselect
                        v-model="optionSelected"
                        :options="itensSituation"
                        :placeholder="$ml.get('selectCountry')"
                        :searchable="true"
                        label="name"
                        :custom-label="nameLang"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        :preselect-first="true"
                        :multiple="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      type="checkbox"
                      id="checkTerms"
                      v-model="checkTerms"
                      name="check"
                    />
                    <label class="form-check-label label-text" for="checkTerms">
                      <font class="m-4"
                        ><font v-text="$ml.get('iAgreeWithThe')"
                          >Eu concordo com o
                        </font>
                        <a
                          href="https://www.bughunt.com.br/termos-de-uso.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ $ml.get('termsOfUse') }}
                        </a>
                        {{ $ml.get('and') }}
                        <a
                          href="https://bughunt.com.br/codigo-de-conduta.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ $ml.get('codeOfConduct') }}</a
                        >.</font
                      >
                    </label>
                  </div>
                  <transition name="fade">
                    <label v-if="userError && !checkTerms" class="lblError">{{
                      $ml.get('youMustAgreeToTheTermsOfUseAndCodeOfConduct')
                    }}</label>
                  </transition>

                  <div class="d-flex justify-content-center mt-3">
                    <RecaptchaV2 ref="recaptcha" @verify="setRecaptchaToken" @expired="tokenRecaptcha = ''" />
                  </div>

                  <div class="row m-0 mt-2 mb-2">
                    <div class="col-auto w-100">
                      <button
                        :disabled="loadingBtn || !tokenRecaptcha"
                        @click="registerAccount()"
                        class="btn btnForm m-0 mr-2 mt-2"
                      >
                        <Spinner v-show="loadingBtn" />
                        <span
                          v-show="!loadingBtn"
                          v-text="$ml.get('createMyAccount')"
                        >
                          Criar minha conta!</span
                        >
                      </button>

                      <router-link
                        to="/login"
                        class="btn btnForm btn-outline-extra mt-2"
                        v-text="$ml.get('iAlreadyHaveAnSccount')"
                      >
                        Eu já tenho conta!
                      </router-link>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators';
import RecaptchaV2 from '../../components/recaptchaV2.vue';
import Translate from '../../components/translate.vue';
import { listCountries } from '../../helpers/mocks';
import { utils } from '../../utils';
const regexOTN = utils.regexCheck('OTN');
const regexRSC = utils.regexCheck('RSC');

export default {
  components: {
    RecaptchaV2,
    Translate,
  },
  page: {
    title: 'Cadastro',
    meta: [{ name: 'description' }],
  },
  data() {
    return {
      username: '',
      name: '',
      email: '',
      password: '',
      passwordConfirm: '',
      userError: false,
      checkTerms: false,
      loadingBtn: false,
      msgdanger: '',
      msgWarning: '',
      msgSuccess: '',
      seconds: 5,
      requestError: "",
      messageErrorApi:{
        name: 'Nome completo não é válido! OTN'
      },
      rules: [
        { message: 'aNumber', regex: /[0-9]+/ },
        { message: 'anUppercaseLetter', regex: /[A-Z]+/ },
        { message: 'aLowercaseLetter', regex: /[a-z]+/ },
        { message: 'atLeastCharacters', regex: /.{6,}/ },
      ],

      optionSelected: {
        name: 'brasil',
        value: 'br',
      },
      itensSituation: listCountries,
      tokenRecaptcha: '',
    };
  },
  validations: {
    username: { required, regexRSC, minLength: minLength(3) },
    name: { required, regexOTN, minLength: minLength(3) },
    email: { required, email },
    passwordConfirm: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  computed: {
    passwordValidation() {
      const errors = [];

      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errors.push(this.$ml.get(condition.message));
        }
      }
      let errorsString = '';

      if (errors.length) {
        errorsString = `${this.$ml.get('thePasswordMustHave')}, ${errors.join(', ')}`;
      } else {
        errorsString = '';
      }

      return { errorsString };
    },
    preferredLanguage() {
      if (this.$ml.current == 'english') {
        return 'en';
      } else if (this.$ml.current == 'spanish') {
        return 'es';
      }
      return 'pt';
    },
  },

  watch:{
    name(){
      this.requestError = "";
    }
  },
  methods: {
    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },

    registerAccount() {
      var self = this;

      // stop here if form is invalid
      this.$v.$touch();
      if (
        this.$v.$invalid ||
        !this.checkTerms ||
        this.passwordValidation.errorsString
      ) {
        this.userError = true;
        return;
      }

      this.loadingBtn = true;

      this.userError = false;
      this.msgdanger = '';
      this.msgWarning = '';
      this.msgSuccess = '';

      delete axios.defaults.headers.common['Authorization'];
      self.username = self.username.trim();
      self.username = self.username.replace(/\s\s+/g, ' ');
      axios
        .post(this.$store.getters['getApiUrl'] + `hacker`, {
          name: self.name,
          username: self.username.trim(),
          email: self.email,
          password: self.password,
          tokenRecaptcha: this.tokenRecaptcha,
          language: self.preferredLanguage,
          country: self.optionSelected.value,
          termsUseConduct: this.checkTerms,
        })
        .then(function (response) {
          self.msgSuccess = response.data.username;
          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
              self.loadingBtn = false;
              self.$router.push({
                name: 'login',
                params: {
                  email: self.email,
                },
              });
              clearInterval(refreshInterval);
            }
          }, 1000);
        })
        .catch(function (error) {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;

          if(error.response.data.message[0] === self.messageErrorApi.name){
            self.requestError = self.messageErrorApi.name;
            return;
          }
          if (error.response.status == 404) {
            self.msgdanger = self.$ml.get('unableToCompleteThisRequest');
            return;
          }
          if (error.response.status == 400) {
            self.msgWarning = self.$ml.get(
              'emailAlreadyRegisteredInOurDatabase'
            );
            return;
          }
          if (error.response.data.statusCode == 425) {
            self.msgWarning = self.$ml.get('unableToCompleteThisRequest');
            return;
          }
          if (error.response.status == 422) {
            self.msgWarning = self.$ml.get('theTokenMustBeEntered');
          }
        });
    },
    setRecaptchaToken(token) {
      this.tokenRecaptcha = token;
    },
  },
};
</script>

<style>
.btnForm {
  width: 173px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.form-group {
  margin-bottom: 20px;
}

/*General style*/
.form-check-label {
  cursor: pointer;
  color: #666;
  font-size: 15px;
  margin-left: -12px;
}

/*Custom checkboxes style*/
.custom-checkbox input[type='checkbox'] + .label-text:before {
  content: '';
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type='checkbox']:checked + .label-text:before {
  content: '✓';
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}

@keyframes effect {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1.3);
  }
  75% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
</style>
